////////////////////////////////////////////////////////////
//     							                                      //
//  Program: ForgotPassword.jsx                           //
//  Application: authentication                           //
//  Option: For ForgotPassword into project               //
//  Developer: PS  						                            //
//  Date: 2022-04-25                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from 'react'
import AuthenticationService from '../../services/AuthenticationService'
import SimpleReactValidator from 'simple-react-validator'
import { Redirect,Link } from 'react-router-dom'
import BackButton from "../../assets/images/back-button.svg"
import Alerts from '../common/Alerts' 

class ForgotPassword extends Component {
  constructor(props) {
      super(props)

      this.validator = new SimpleReactValidator({autoForceUpdate: this});

      this.state = {
            headerToken: localStorage.getItem('headerToken'),
            isSubmit: false,
            showAlertModal: false,
            alertModalType: '',
            alertModalTitle: '',
            alertModalMessage: '',
            email: '',
      }
      
      this.closeModal = this.closeModal.bind(this);
      this.changeHandler = this.changeHandler.bind(this);
      this.forgotPass = this.forgotPass.bind(this);
  }

  closeModal() {
      this.setState({ showAlertModal: false });
  }

  forgotPass = async (e) => {
      e.preventDefault();
      if(this.validator.allValid()){ // Validate all fields before data submission
          this.setState({isSubmit: true});
          let input = {
                email: this.state.email,          
          }
          let res = await AuthenticationService.forgotPass(input);
          if((global.successStatus).includes(res.status)) {
            localStorage.clear();
            this.setState({ showAlertModal: true, alertModalType: 'success', alertModalTitle: 'Success', alertModalMessage: res.message ? res.message :'Success' });
            setTimeout(() => this.props.history.push('/signin'), global.redirect_time);
          }else if(res.status === 400){
            this.setState({ showAlertModal: true, alertModalType: 'error', alertModalTitle: 'Error', alertModalMessage: res.data.message ? res.data.message : 'Error'}); 
          }else{
              this.setState({ showAlertModal: true, alertModalType: 'error', alertModalTitle: (res.data.errorCode) ? res.data.errorCode : 'Error!', alertModalMessage: (res.data.message) ? res.data.message : '' });
          }
          this.setState({isSubmit: false});
          setTimeout(() => this.setState({ showAlertModal: false }), global.alert_close_time);
      }else{
          this.validator.showMessages();
      }
  }

  changeHandler = (event) => {
      this.setState({[event.target.name]:event.target.value});

      // Validate
      this.validator.showMessageFor(event.target.name);
  }

  getTitle() {
      return process.env.REACT_APP_PROJECT_TITLE ? process.env.REACT_APP_PROJECT_TITLE : '';
  }

  render() {
    // Redirect to dashboard if logged in 
    if(this.state.headerToken) {
        return <Redirect to='/dashboard' />;
    }
    return (
      <div className="authentication d-flex flex-wrap">
          <div className="az-signin-wrapper"></div>
          <div className="az-card-signin">
              <div className="az-logo d-flex flex-column">
              <img
              src={require("../../assets/images/GFBOT-Horizontal.png").default}
              alt=""
            ></img>
               </div>
              <div className="az-signin-header">
                <h3 className='text-left'>Forgot your password?</h3>
                <p className='text-left p-dark forgot-text'>Enter your email address, and we’ll send you instructions to reset it.</p>
                  <div className="col-md-12 pl-0 pr-0">
                      <Alerts show={this.state.showAlertModal} type={this.state.alertModalType} title={this.state.alertModalTitle} message={this.state.alertModalMessage} />
                  </div>
                <form action="#/">
                  <div className="form-group">
                  <label>Email</label>
                    <input name="email" className="form-control"
                        value={this.state.email} onChange={this.changeHandler} maxLength="50" />

                    {this.validator.message('email', this.state.email, 'email|required', { className: 'valid_info' })}
                  </div>
                  <button className="btn btn-info btn-block button-green" onClick={this.forgotPass} disabled={ this.state.isSubmit ? true : false }>{ this.state.isSubmit ? global.loader : "Submit" }</button>

                  <div className="az-signin-footer text-left mt-3">
                    <p  className="d-flex justify-content-start align-items-center"><Link to="/signin"><img src={BackButton} alt="" className="back-button m-0" /></Link><Link to="/signin" className="ml-2">Back to Login</Link></p>
                  </div>
                </form>
              </div>
            </div>
      </div>
    )
  }
}

export default ForgotPassword
